import React, { useState, useEffect } from 'react';
import RolesConfig from "../../config/Roles";
import { useLocale } from "../../i18n/localeContext";
import { getApplictionDataPage } from "../../Api/content";
import { Skeleton } from "antd";

function DetailHeader({
  solicitudDetalle,
  roles,
  atendidoPor,
  setShowModalReasignar,
  usuarioId,
  modalEstadoSolicitud,
  ableInputs,
  setInputsHabilitados,
  inputsHabilitados,
  btnActualizar,
  ActualizacionParcial,
  handleSubmit,
  actualizacionParcial,
  actualizar,
}) {  
  const { locale } = useLocale();
  const [applictionDataPage, setApplictionDataPage] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const Rol = RolesConfig;

  useEffect(() => {
    let cancel = false;
    setIsLoadingContent(true);
    getApplictionDataPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setApplictionDataPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => { 
        if (!cancel) {
          setApplictionDataPage(null);
          setIsLoadingContent(false);
        }
      });
    return () => { cancel = true };
  }, [locale])

  if (isLoadingContent) {
    return (
      <div className="controls-sticky">
        <div className="divAction">
          <div>
            <Skeleton.Input style={{ width: 200, height: 30 }} active />
            <Skeleton.Input style={{ width: 300, height: 20 }} active />
          </div>
          <div style={{ display: "flex", gap: 20, alignItems: "center", alignSelf: "center" }}>
            <Skeleton.Button style={{ width: 100, height: 40 }} active />
            <Skeleton.Button style={{ width: 100, height: 40 }} active />
            <Skeleton.Button style={{ width: 100, height: 40 }} active />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="controls-sticky">

      <div className="divAction">
        <div>
          <h2 id="codigo-solicitud">
            {applictionDataPage?.application_navbar.title || "Solicitud no."} {solicitudDetalle?.numero}:
          </h2>
          <div className="subtitulo-solicitud mt-2 mb-2">
            {solicitudDetalle?.nombres} {solicitudDetalle?.primerApellido}{" "}
            {solicitudDetalle?.segundoApellido}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            gap: 20,
            alignItems: "center",
            alignSelf: "center",
          }}
        >
          {solicitudDetalle?.academicGStatus && (
            <i
              className="material-icons"
              style={{
                fontSize: 30,
                color: "#016AE9",
                cursor: "pointer",
              }}
              title={"Se ha graduado"}
            >
              
            </i>
          )}
          {solicitudDetalle?.tieneMatricula && (
            <i
              className="material-icons"
              style={{
                fontSize: 30,
                color: "#016AE9",
                cursor: "pointer",
              }}
              title={"Existe en power campus"}
            >
              how_to_reg
            </i>
          )}
        <div>
          {solicitudDetalle?.estadoId != 10 &&
          solicitudDetalle?.estadoId != 13 &&
          solicitudDetalle?.estadoId != 17 ? (
            //if dependiendo del rol

              (roles?.includes(Rol.oficialAdmisiones) &&
                solicitudDetalle?.estadoId == 9) ||
              solicitudDetalle?.estadoId == 8 ? (
                atendidoPor == null ? (
                  <>
                    {roles?.includes(Rol.DIRECTOR) && (
                      <>
                        <div className="btnGroupAction">
                          <button
                            className="btnPrimary"
                            onClick={() => {
                              setShowModalReasignar(true);
                            }}
                          >
                            Asignar
                          </button>
                        </div>
                      </>
                    )}
                  </>
                ) : usuarioId === atendidoPor || roles?.includes(Rol.ADMIN) ? (
                  <div className="btnGroupAction">
                    <button
                      className="btnPrimary"
                      onClick={() => {
                        setShowModalReasignar(true);
                      }}
                    >
                      {applictionDataPage?.application_navbar.realsign || "Reasignar"}
                    </button>

                    {solicitudDetalle?.estadoId == 9 ? (
                      <>
                        <button
                          className="btnYellow"
                          onClick={() => {
                            modalEstadoSolicitud(true, 17);
                          }}
                        >
                          {applictionDataPage?.application_navbar.return || "Devolver"}
                        </button>
                        <button
                          className="btnBlue"
                          onClick={() => {
                            modalEstadoSolicitud(true, 18);
                          }}
                        >
                          {applictionDataPage?.application_navbar.preaprove || "Preaprobar"}
                        </button>
                        <button
                          className="btnOutline"
                          onClick={() => {
                            modalEstadoSolicitud(true, 13);
                          }}
                        >
                          {applictionDataPage?.application_navbar.decline || "Rechazar"}
                        </button>
                        <button
                          id="solicitudEdit"
                          onClick={() => {
                            ableInputs();
                            setInputsHabilitados(!inputsHabilitados);
                          }}
                        >
                          <i className="material-icons"></i>
                        </button>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                ) : (
                  <span className="subtitulo-solicitud">
                    Atendido por: {solicitudDetalle?.atendidoPorNombre}
                  </span>
                )
              ) : roles?.includes(Rol.DIRECTOR) &&
                solicitudDetalle?.estadoId == 18 ? (
                <>
                  <div className="btnGroupAction">
                    <button
                      className="btnYellow"
                      onClick={() => {
                        modalEstadoSolicitud(true, 17);
                      }}
                    >
                      {applictionDataPage?.application_navbar.return || "Devolver"}
                    </button>
                    <button
                      className="btnBlue"
                      onClick={() => {
                        modalEstadoSolicitud(true, 19);
                      }}
                    >
                      Aprobar
                    </button>
                    <button
                      className="btnOutline"
                      onClick={() => {
                        modalEstadoSolicitud(true, 13);
                      }}
                    >
                      {applictionDataPage?.application_navbar.decline || "Rechazar"}
                    </button>
                    <button
                      id="solicitudEdit"
                      onClick={() => {
                        ableInputs();
                        setInputsHabilitados(!inputsHabilitados);
                      }}
                    >
                      <i className="material-icons"></i>
                    </button>
                  </div>
                </>
              ) : (
                roles?.includes(Rol.REGISTRO) &&
                solicitudDetalle?.estadoId == 19 && (
                  <>
                    <div className="btnGroupAction">
                      <button
                        className="btnYellow"
                        onClick={() => {
                          modalEstadoSolicitud(true, 20);
                        }}
                      >
                        {applictionDataPage?.application_navbar.return || "Devolver"}
                      </button>
                      <button
                        className="btnBlue"
                        onClick={() => {
                          modalEstadoSolicitud(true, 10);
                        }}
                      >
                        Aprobar
                      </button>
                      <button
                        className="btnOutline"
                        onClick={() => {
                          modalEstadoSolicitud(true, 13);
                        }}
                      >
                        {applictionDataPage?.application_navbar.decline || "Rechazar"}
                      </button>
                    </div>
                  </>
                )
              )
            ) : (
              <span className="subtitulo-solicitud">
                Atendido por: {solicitudDetalle?.atendidoPorNombre}
              </span>
            )}
            <div className="mt-2 mb-2 d-flex">
              <span className="subtitulo-solicitud ">
                {applictionDataPage?.application_navbar.status_application || "Estado actual"}: {solicitudDetalle?.estadoNombre}
              </span>
  
          {solicitudDetalle.estaEnBaja && (
            <div className="mt-2 mb-2 d-flex">
              <span className="subtitulo-solicitud text-red">En baja académica</span>
            </div>
          )}
          

              <button
                type="submit"
                className="btnActualizar invisibleBtn ml-3"
                ref={btnActualizar}
                onClick={
                  ActualizacionParcial == true
                    ? handleSubmit(actualizacionParcial)
                    : handleSubmit(actualizar)
                }
              >
                {applictionDataPage?.application_navbar.update_button || "Actualizar"}
              </button>
            </div>
        </div>
      </div>
    </div>
    </div>
          
  );
}

export default DetailHeader;
